import { render, staticRenderFns } from "./ColorSelect.vue?vue&type=template&id=6b36e5ac&scoped=true"
import script from "./ColorSelect.vue?vue&type=script&lang=js"
export * from "./ColorSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36e5ac",
  null
  
)

export default component.exports